<template>
  <header class="header" :class="{scrolled: headerStyle === 'sub'}">
    <router-link to="/" exact class="header__logo">
      <img
        v-if="!fixedHeader"
        src="~/assets/images/header-logo.png"
        alt="giftiel"
      />
      <img
        v-if="fixedHeader"
        src="~/assets/images/header-logo-reverse.png"
        alt="giftiel"
      />
    </router-link>
    <div class="gnb">
      <!-- main route -->
      <ul v-if="headerStyle === 'main'" class="gnb__ul">
        <li class="gnb__li">
          <div class="gnb__anchor is-active" @click="go($event, '#service')">서비스</div>
        </li>
        <li class="gnb__li">
          <div class="gnb__anchor" @click="go($event, '#brand')">브랜드</div>
        </li>
        <li class="gnb__li">
          <div class="gnb__anchor" @click="go($event, '#guide')">비즈몰</div>
        </li>
        <li class="gnb__li">
          <div class="gnb__anchor" @click="go($event, '#customer')">고객지원</div>
        </li>
        <li class="gnb__li">
          <div class="gnb__anchor" @click="go($event, '#contact')">제휴문의</div>
        </li>
      </ul>
      <!-- sub route -->
      <ul v-else class="gnb__ul">
        <li class="gnb__li">
          <router-link to="/?section=0" class="gnb__anchor">
            서비스
          </router-link>
        </li>
        <li class="gnb__li">
          <router-link to="/?section=1" class="gnb__anchor">
            브랜드
          </router-link>
        </li>
        <li class="gnb__li">
          <router-link to="/?section=2" class="gnb__anchor">
            이용안내
          </router-link>
        </li>
        <li class="gnb__li">
          <router-link to="/?section=3" class="gnb__anchor">
            고객지원
          </router-link>
        </li>
        <li class="gnb__li">
          <router-link to="/?section=4" class="gnb__anchor">
            제휴문의
          </router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    headerStyle: {
      type: String,
      default: 'main'
    },
    go: {
      type: Function,
      default: null
    },
    fixedHeader: {
      type: Boolean,
      defaults: false
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/mixin.scss';

.header {
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 22px;
  width: 100%;
  height: 109px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background-color: transparent;
  @include flexbox();
  @include justify-content(space-between);
  @include align-items(center);
  @include css-prefix(
    transition,
    'background-color 300ms linear,
    padding-top 300ms linear, height 300ms linear'
  );
  &__logo {
    width: 50%;
    display: block;
  }
  z-index: 300;
  &.scrolled {
    padding-top: 0;
    background-color: #e31d1a;
    height: 65px;
    .gnb__anchor {
      height: 65px;
      &.is-active::before {
        left: 50%;
        @include css-prefix(transform, translateX(-50%));
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #fff;
        background: none;
        display: block;
        content: '';
      }
    }
  }
}
.gnb {
  width: 634px;
  &__ul {
    @include flexbox();
    @include justify-content(flex-start);
    @include align-items(center);
  }
  &__li {
    width: 20%;
  }
  &__anchor {
    height: 87px;
    position: relative;
    display: block;
    font-size: 19px;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    @include flexbox();
    @include justify-content(center);
    @include align-items(center);
    &.is-active {
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #fff;
        content: '';
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue